import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Button, Image } from "react-bootstrap";
import { auth, db } from "../../Firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import Close from "../../images/close-icon.svg";
import { toast } from 'react-toastify';

const EditProfileModal = ({ showEditProfile, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: ""
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (auth.currentUser) {
          const userRef = doc(db, "users", auth.currentUser.uid);
          const docSnap = await getDoc(userRef);
          if (docSnap.exists()) {
            const userData = docSnap.data();
            setFormData({
              name: userData.name || "",
              email: userData.email || "",
              phone: userData.phone || ""
            });
          }
        }
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };

    if (showEditProfile) {
      fetchUser();
    }
  }, [showEditProfile]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      if (!auth.currentUser) throw new Error("No user logged in");

      const userRef = doc(db, "users", auth.currentUser.uid);
      await updateDoc(userRef, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
      });

      toast.success("Profile updated successfully");
      setLoading(false);
      onClose();

    } catch (err) {
      setLoading(false);
      toast.error("Failed to update profile: " + err.message);
    }
  };



  return (
    <Modal
      show={showEditProfile}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="password-modal-content"
      dialogClassName="password-modal-dialog"
    >
      <Link
        onClick={onClose}
        className="modal-close-floating"
        aria-label="Close"
      >
        <Image src={Close} alt="Close" />
      </Link>

      <Modal.Body className="password-modal-body p-0">
        <div className="head-bg">
          <h5 className="password-modal-title">Edit Profile</h5>
        </div>
        <div className="inner-modal-content inner-radius">
          <p>Edit or update your personal information to keep your profile current and accurate.</p>

          <form className="mt-4">
            <div className="form-field">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="John Doe"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-field">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="johndoe@squch.com"
                value={formData.email}
                onChange={handleChange}
                readOnly
                disabled
              />
            </div>
            <div className="form-field">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="1234567890"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </form>
        </div>
      </Modal.Body>

      <div className="d-flex gap-2 justify-content-end btn-footer px-3 pb-3">
        <Button variant="secondary" className="modal-btn cancel-btn" onClick={onClose}>
          Cancel
        </Button>
        <Button className="login-button m-0" onClick={handleSave} disabled={loading}>
          {loading ? "Saving..." : "Save Details"}
        </Button>
      </div>
    </Modal>
  );
};

export default EditProfileModal;
